import { Button } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";

const MANavbar = ({ toggleSidebar }) => {
  const toggleFullScreen = () => {
    if (document.fullscreenEnabled) {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    }
  };

  return(
    <div className="navbar navbar-expand-lg navbar-light shadow-sm px-3">
    <Link to="/" className="navbar-brand d-flex align-items-center">
      <img src="/assets/images/logo.png" alt="Logo" height="50" />
    </Link>

    <FaBars
      size={20}
      onClick={toggleSidebar}
      style={{ cursor: "pointer", marginLeft: "1rem" }}
    />

    <div className="ms-auto d-flex align-items-center gap-3">
      <i
        datafullscreen="true"
        className="i-Full-Screen header-icon d-none d-sm-inline-block"
        onClick={toggleFullScreen}
        style={{ cursor: "pointer", fontSize: "1.5rem" }}
      />
      <div
        className="position-relative"
        style={{ cursor: "pointer", fontSize: "1.5rem" }}
      >
        <i className="i-Bell text-muted header-icon" />
      </div>
      <Button>Logout</Button>
    </div>
  </div>
  )
};

export default MANavbar;
